/**
 * ACORDE — Favoritos guardados en el teléfono del cliente.
 *
 * No necesita cuenta ni app: la lista vive en localStorage bajo la clave `acorde_favoritos`
 * como un arreglo de handles de producto. Cada corazón (<acorde-favorito data-handle>) la lee
 * y la escribe; al cambiar, avisa con el evento `acorde:favoritos` para que todos se actualicen.
 */
const CLAVE = 'acorde_favoritos';

function leer() {
  try {
    const lista = JSON.parse(localStorage.getItem(CLAVE) || '[]');
    return Array.isArray(lista) ? lista : [];
  } catch {
    return [];
  }
}

function guardar(lista) {
  try {
    localStorage.setItem(CLAVE, JSON.stringify(lista));
  } catch {
    // Sin almacenamiento (modo privado, por ejemplo): el corazón funciona solo durante la visita.
  }
}

class AcordeFavorito extends HTMLElement {
  connectedCallback() {
    this.boton = this.querySelector('button');
    this.handle = this.dataset.handle;
    if (!this.boton || !this.handle) return;

    this.pintar();
    this.boton.addEventListener('click', (evento) => {
      evento.preventDefault();
      evento.stopPropagation();
      const lista = leer();
      const posicion = lista.indexOf(this.handle);
      if (posicion >= 0) lista.splice(posicion, 1);
      else lista.push(this.handle);
      guardar(lista);
      document.dispatchEvent(new CustomEvent('acorde:favoritos', { detail: lista }));
    });
    this.alCambiar = () => this.pintar();
    document.addEventListener('acorde:favoritos', this.alCambiar);
  }

  disconnectedCallback() {
    document.removeEventListener('acorde:favoritos', this.alCambiar);
  }

  pintar() {
    const activo = leer().includes(this.handle);
    this.boton.setAttribute('aria-pressed', String(activo));
  }
}

if (!customElements.get('acorde-favorito')) {
  customElements.define('acorde-favorito', AcordeFavorito);
}

export { leer as leerFavoritos };
